import api from '../api'

const fetchUser = () => {
  return api.get('/v2/users/me')
}

const fetchUsers = (params = {}) => {
  return api.get('/users/app', { params: { 'farmUsers.farm': atob(window.localStorage.getItem('farm-id')), ...params } })
}

const fetchUsersByUuid = (id, params = {}) => {
  return api.get(`/users/${id}`, { params: { ...params } })
}

const createUser = (body = {}) => {
  return api.post('/users', body)
}

const updateUser = (id, body = {}) => {
  return api.put(`/users/${id}`, body)
}

const deleteUser = (id) => {
  return api.delete(`/users/${id}`)
}

const changePasswordUser = (body) => {
  return api.post('/users/change_password', body)
}

export { fetchUser, fetchUsers, fetchUsersByUuid, createUser, updateUser, deleteUser, changePasswordUser }
